// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useMemo} from 'react';
import {use_plans} from './plans';
import {t_toolip_proxy_type} from '../../types';

const get_prices = (plans, type, period)=>{
    if (!plans[type])
        return null;
    let product = [];
    if (period)
    {
        if (plans[type].hasOwnProperty(period))
            product = plans[type][period];
    }
    else
        product = plans[type]['1w'] || [];
    if (!product)
        product = [];
    const prices: number[] = [];
    const plan_ids: string[] = [];
    const ips_amount: number[] = [];
    const gb_amount: number[] = [];
    const prices_per_ip: number[] = [];
    const prices_per_gb: number[] = [];
    for (let i = 0; i < product.length; i++)
    {
        const plan = product[i].plan;
        prices.push(plan.price);
        plan_ids.push(plan.id);
        if (product[i]?.ips_amount)
        {
            const value = product[i].ips_amount;
            const price_per_ip = (plan.price / value).toFixed(2);
            ips_amount.push(value);
            prices_per_ip.push(+price_per_ip);
        }
        if (product[i]?.limit)
        {
            const value = product[i].limit;
            const price_per_gb = (plan.price / value).toFixed(2);
            gb_amount.push(value);
            prices_per_gb.push(+price_per_gb);
        }
    }
    return {
        prices,
        plan_ids,
        ips_amount,
        prices_per_ip,
        min_price_per_ip: Math.min(...prices_per_ip),
        gb_amount,
        prices_per_gb,
        min_price_per_gb: Math.min(...prices_per_gb),
    };
};

export const use_prices = (period = '1w')=>{
    const {plans} = use_plans();
    const types = Object.keys(plans);
    const prices = useMemo(()=>{
        return types.reduce((acc, type)=>{
            const id_prices = get_prices(plans, type, period);
            if (id_prices)
                acc[type] = id_prices;
            return acc;
        }, {} as Record<t_toolip_proxy_type, ReturnType<typeof get_prices>>);
    }, [plans, period]);
    return {prices, plans};
};
